import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { subscription as subApi } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Crown, XCircle, Loader2 } from "lucide-react";

const SubscriptionSuccess = () => {
  const [params] = useSearchParams();
  const subscriptionId = params.get("subscription_id");
  const [state, setState] = useState("confirming");
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const confirmed = useRef(false);

  useEffect(() => {
    if (!subscriptionId || confirmed.current) return;
    confirmed.current = true;
    (async () => {
      try {
        const res = await subApi.confirm(subscriptionId);
        if (res.status === "active") {
          setState("active");
          refresh();
        } else {
          setState("failed");
        }
      } catch {
        setState("failed");
      }
    })();
  }, [subscriptionId, refresh]);

  return (
    <main
      data-testid="subscription-success-page"
      className="min-h-[70vh] bg-zinc-50 flex items-center justify-center p-6"
    >
      <div className="bg-white border border-zinc-200 max-w-md w-full p-10 text-center">
        {state === "confirming" && (
          <>
            <Loader2 className="w-12 h-12 mx-auto mb-4 text-[#4F46E5] animate-spin" />
            <h1 className="font-display font-black text-2xl mb-2">Activando tu suscripción...</h1>
            <p className="text-zinc-600 text-sm">No cierres esta ventana.</p>
          </>
        )}
        {state === "active" && (
          <>
            <Crown className="w-14 h-14 mx-auto mb-4 text-[#FFC439]" />
            <p className="text-xs uppercase tracking-[0.2em] font-bold text-emerald-600 mb-2">
              Suscripción activa
            </p>
            <h1 className="font-display font-black text-3xl tracking-tighter mb-3">
              ¡Eres Premium!
            </h1>
            <p className="text-zinc-600 mb-6">
              Ya tienes acceso ilimitado a los 40 cursos, videobooks y PDF.
            </p>
            <button
              onClick={() => navigate("/dashboard")}
              data-testid="subscription-goto-dashboard-btn"
              className="w-full bg-[#4F46E5] hover:bg-[#4338CA] text-white py-3.5 font-semibold"
            >
              Ir a mis cursos
            </button>
          </>
        )}
        {state === "failed" && (
          <>
            <XCircle className="w-14 h-14 mx-auto mb-4 text-red-500" />
            <h1 className="font-display font-black text-2xl mb-2">
              No pudimos activar la suscripción
            </h1>
            <p className="text-zinc-600 mb-6 text-sm">
              Si el pago se realizó, escríbenos y lo resolvemos de inmediato.
            </p>
            <Link to="/" className="block w-full bg-zinc-900 text-white py-3.5 font-semibold">
              Volver al inicio
            </Link>
          </>
        )}
      </div>
    </main>
  );
};

export default SubscriptionSuccess;
